
/**
 * @param {*} data Dados da lista
 * @param {*} scope Escopo da tela (Pedido, PedidoVolume, Sugestão)
 * @returns Retorna validadores para os checkbox caso existam.
 * Caso precisar adicionar mais validators, criar nessa classe
 * uma implementação da sua validação para os Escopos necessários.
 */

export const rulesForCheckboxAll = (data, selected, scope) => {
    if (scope === 'Orders' || scope === 'Suggestions' || scope === 'OrderVolume') {
    return selected.length === data.length
  }

  return false
}

export const rulesForCheckbox = (record, selected, scope) => {

  if (scope === 'Orders' || scope === 'Suggestions' || scope === 'OrderVolume') {
    return selected.includes(record.Id)
  }

  return false
}
